import { FEATURE_FLAG_KEYS, type FeatureFlagKey } from './registry'

export type FeatureFlagOverrides = Partial<Record<FeatureFlagKey, boolean>>

export function resolveConfigCatSdkKey(value: string | undefined): string | undefined {
  const key = value?.trim()
  if (!key || key.startsWith('__VENDEPAY')) {
    return undefined
  }
  return key
}

export function parseFeatureFlagOverrides(
  raw: string | undefined,
  warn: (message: string) => void,
): FeatureFlagOverrides {
  if (!raw?.trim()) {
    return {}
  }

  let parsed: unknown
  try {
    parsed = JSON.parse(raw)
  } catch {
    warn('VITE_FEATURE_FLAG_OVERRIDES must be valid JSON.')
    return {}
  }

  if (parsed === null || typeof parsed !== 'object' || Array.isArray(parsed)) {
    warn('VITE_FEATURE_FLAG_OVERRIDES must be a JSON object.')
    return {}
  }

  const overrides: FeatureFlagOverrides = {}
  for (const [key, value] of Object.entries(parsed)) {
    if (!FEATURE_FLAG_KEYS.includes(key as FeatureFlagKey) || typeof value !== 'boolean') {
      warn(`Ignoring invalid feature flag override: ${key}.`)
      continue
    }
    overrides[key as FeatureFlagKey] = value
  }
  return overrides
}
